import CFormGroup from './CForm.Group';
import CFormControl from './CForm.Control';

export const CForm = {
    Group : CFormGroup,
    Control : CFormControl
}